import { NgClass } from '@angular/common'
import { Component, forwardRef, inject, Injector, Input } from '@angular/core'
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms'

@Component({
  selector: 'app-custom-checkbox',
  standalone: true,
  imports: [FormsModule, NgClass],
  templateUrl: './custom-checkbox.component.html',
  styleUrl: './custom-checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CustomCheckboxComponent),
    },
  ],
})
export class CustomCheckboxComponent implements ControlValueAccessor {
  @Input({ required: true }) value!: string
  @Input() hoverColorClass: string = 'text-blue-500'
  private injector = inject(Injector)

  checkBoxValue: boolean = false
  onChange: Function = () => {}
  onTouched: Function = () => {}
  touched = false
  disabled = false

  valueChanged(event: Event) {
    let newValue
    const selfControl = this.injector.get<NgControl | null>(NgControl, null, {
      optional: true,
      self: true,
    })
    const currentValue = selfControl?.value || []

    if (this.checkBoxValue) {
      newValue = [...currentValue, this.value]
    } else {
      newValue = currentValue.filter((val: any) => val !== this.value)
    }
    this.onChange(newValue)
  }

  writeValue(formSocieties: string[]): void {
    this.checkBoxValue = formSocieties.includes(this.value)
  }

  registerOnChange(fn: Function): void {
    this.onChange = fn
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched()
      this.touched = true
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
}
